/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React from 'react';
import Row from 'antd/lib/grid/row';
import { Button, Input } from 'antd';
import { css } from '@emotion/core';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router';
import { InfoContainer,MessageBody } from './styled';
import { fontSize } from '../../../constants/theme';
import IconSvg from '../../common/IconSvg';
// import Checkout from '../../Checkout';
import ENUMS from '../../../constants/enums';
import Spinner from '../../common/spinner';

const { DANGER, WARNING, INFO } = ENUMS.TOAST_TYPES;

@inject('settingsStore')
@inject('onboardingStore')
@inject('toastsStore')
@observer
class CourseOffer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethod: "",
      openCheckout: false,
      isReadyToPay: false,
      spinnerShown: false,
      couponCode: "",
    };
  }

  componentDidMount() {
  }

  handlePaypalMethodChange = () => {
    const {
      settingsStore: {
        subscription: { billingPaypalAccountId },
      }
    } = this.props;

    this.setState({ paymentMethod: "paypal" });

    if (billingPaypalAccountId === null) {
      this.setState({ openCheckout: true });
    } else {
      this.setState({ isReadyToPay: true })
    }

  };

  handlePayoneerMethodChange = () => {
    const {
      settingsStore: {
        subscription: { billingPayoneerAccountId },
        connectionManagement: { connectPayoneerAccount },
      }
    } = this.props;

    if (billingPayoneerAccountId === null) {
      connectPayoneerAccount();
    }

    this.setState({ isReadyToPay: true })

    this.setState({ paymentMethod: "payoneer" });
  };

  render() {
    const {
      settingsStore: {
        subscription: {
          purchaseCourse,
          checkUserHasCourse,
          checkCouponCode,
          hasCourseDiscount,
          userHasCourse,
          fetchSubscription,
          addOns,
        },
      },
      toastsStore,
      onboardingStore: { toggleWizard, setIsPaypalCardOption }
    } = this.props;
    const { paymentMethod, openCheckout, isReadyToPay, spinnerShown, couponCode } = this.state;
    const coursePrice = addOns.filter(x => x.id === "course")[0]?.plans[0]?.cost;
    const courseDiscount = ((coursePrice * 15) / 100).toFixed(2);

    return (
      <InfoContainer>
        {
          userHasCourse && (
            // <div css={css`display:flex;justify-content:center;flex-direction:column;margin-top:20px;font-size:${fontSize.large};height:300px;`}>
            //   <p css={css`display:flex;justify-content:center;`}>Thank you for purchasing the course.</p>
            //   <p css={css`display:flex;justify-content:center;`}>The course is now available in the <Link to="/learning" onClick={() => toggleWizard()} css={css`margin-left:5px;`}>Online Course.</Link></p>
            // </div>
            <MessageBody css={css`text-align:start;`}>
              <div css={css`display:flex;justify-content:center;font-size:20px;font-weight:bold;`}>
                <FormattedMessage id="newsPopUp.courseTitleMessage" />
              </div>
              <FormattedMessage id="Are you ready to supercharge your journey with us? We're thrilled to introduce our latest offer exclusively for new members - a FREE Gift that's bound to take your experience to the next level!\n" />
              <div css={css`font-weight:bold;`}>
                <FormattedMessage id="newsPopUp.courseHeaderMessage" />
              </div>
              <FormattedMessage id="newsPopUp.courseBodyMessage" />
              <Link to="/learning" onClick={() => toggleWizard()} css={css`margin-left:5px;`}><FormattedMessage id="newsPopUp.courseClickMessage" /></Link>
            </MessageBody>
          )
        }
        {
          !userHasCourse && (
            <div>
              <Row css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line1" /></Row>
              <Row css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line2" /></Row>
              <Row css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line3" /></Row>
              <Row css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line4" /></Row>
              <Row css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line5" /></Row>
              <Row css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line6" /></Row>
              <Row style={hasCourseDiscount ? { fontSize: `${fontSize.large}`, textDecoration: 'line-through' } : { fontSize: `${fontSize.large}` }}>Course price {coursePrice}$</Row>
              {hasCourseDiscount && (
                <Row css={css`font-size:${fontSize.large};`}>Course price after discount {coursePrice - courseDiscount}$</Row>
              )}
              {!hasCourseDiscount && (
                <Row css={css`font-size:${fontSize.medium};margin-top:10px; margin-bottom:10px;align-items:center;`}>
                  <a>Have a coupon?</a>
                  <Input type='text' style={{ width: '100px', marginLeft: '10px', marginRight: '10px' }} onChange={(e) => { this.setState({ couponCode: e.target.value }) }} />
                  <Button onClick={() => checkCouponCode(couponCode)} type='primary'>Apply</Button>
                </Row>
              )}
              {!openCheckout && (
                <div>
                  {isReadyToPay && (
                    <div css={css`display:flex;justify-content:space-evenly;margin-top:60px;`}>
                      {/* <Button
                        size="large"
                        type="primary"
                        onClick={() => this.setState({ isReadyToPay: false })}
                      >
                        Connect another
                      </Button> */}
                      <Button
                        cssProps={{
                          padding: 'padding: 0 20px',
                          borderRadius: '20px',
                          marginBottom: '5px',
                          marginRight: '5px',
                        }}
                        disabled={paymentMethod?.length <= 0 || userHasCourse}
                        size="large"
                        type="primary"
                        onClick={() => {
                          this.setState({ spinnerShown: true })
                          purchaseCourse(paymentMethod, null, hasCourseDiscount ? courseDiscount : 0)
                            .then((resp) => {
                              checkUserHasCourse();
                              fetchSubscription();
                              if (resp) {
                                toastsStore.showToast({
                                  type: INFO,
                                  message: 'Dropshipping Course purchased successfully!',
                                });
                                this.setState({ spinnerShown: false })
                              } else {
                                toastsStore.showToast({
                                  type: WARNING,
                                  message: 'Something went wrong, please try again!',
                                });
                                this.setState({ spinnerShown: false })
                              }
                            }).catch(() => {
                              toastsStore.showToast({
                                type: DANGER,
                                message: 'Something went wrong, please try again!',
                              })
                              this.setState({ spinnerShown: false })
                            })
                        }
                        }
                      >
                        <FormattedMessage id="course.purchase" />
                      </Button>
                    </div>
                  )}
                  {
                    !isReadyToPay && (
                      (
                        <div
                          css={css`
                            margin-top: 30px;
                            display:flex;
                            justify-content:space-evenly;
                          `}
                        >
                          <Button
                            id="payoneer"
                            cssProps={{
                              padding: 'padding: 0 20px',
                              borderRadius: '20px',
                              marginBottom: '5px',
                              marginRight: '5px',
                            }}
                            size="large"
                            type={paymentMethod === 'payoneer' ? "secondary" : "primary"}
                            onClick={() => this.handlePayoneerMethodChange()}
                          >
                            <FormattedMessage id="balance.loadViaPayoneer" />
                            <IconSvg type="payoneer" size="20" marginLeft="5px" />
                          </Button>
                          {/* <Button
                            cssProps={{
                              padding: 'padding: 0 20px',
                              borderRadius: '20px',
                              marginBottom: '5px',
                              marginRight: '5px',
                            }}
                            disabled="true"
                            size="large"
                            type={paymentMethod === 'paypal' ? "secondary" : "primary"}
                          // onClick={() => this.handlePaypalMethodChange()}
                          >
                            <FormattedMessage id="balance.loadViaPaypalComingsoon" />
                            <IconSvg type="paypal" size="20" marginLeft="5px" />
                          </Button> */}

                          <Button
                            cssProps={{
                              padding: 'padding: 0 20px',
                              borderRadius: '20px',
                              marginBottom: '5px',
                              marginRight: '5px',
                            }}
                            size="large"
                            type={paymentMethod === 'paypal' ? "secondary" : "primary"}
                            onClick={() => this.handlePaypalMethodChange()}
                          >
                            <FormattedMessage id="balance.loadViaPaypal" />
                            <IconSvg type="paypal" size="20" marginLeft="5px" />
                          </Button>
                        </div>
                      )
                    )}
                </div>
              )}
              <div>
                {paymentMethod === 'paypal' && (
                  <PayPalScriptProvider
                    options={{ "client-id": `${process.env.REACT_APP_PAYPAL_CLIENT_ID}` }}
                  >
                    <PayPalButtons
                      css={css`margin-top:20px;`}
                      fundingSource='paypal'
                      onClick={(data) => { data.fundingSource === 'paypal' ? setIsPaypalCardOption(false) : setIsPaypalCardOption(true); }}
                      createOrder={(data, actions) => {
                        return actions.order.create({
                          purchase_units: [
                            {
                              amount: {
                                // TO DO: hardcode here in case service will be down for some reason we will prevent for paying 0 for course 
                                value: hasCourseDiscount ? coursePrice - courseDiscount : coursePrice
                              },
                            }
                          ]
                        })
                      }}
                      onApprove={(data, actions) => {
                        return actions.order.capture().then((details) => {
                          purchaseCourse(paymentMethod, details.id, hasCourseDiscount ? courseDiscount : 0)
                            .then((resp) => {
                              setIsPaypalCardOption(false)
                              checkUserHasCourse();
                              fetchSubscription();
                              if (resp) {
                                toastsStore.showToast({
                                  type: INFO,
                                  message: 'Dropshipping Course purchased successfully!',
                                });
                              } else {
                                toastsStore.showToast({
                                  type: WARNING,
                                  message: 'Something went wrong, please try again!',
                                });
                              }
                            }).catch(() => {
                              toastsStore.showToast({
                                type: DANGER,
                                message: 'Something went wrong, please try again!',
                              })
                            })
                          // console.log("paypal-response", details)
                        })
                      }}
                    />
                  </PayPalScriptProvider>
                  // <Checkout
                  //   forOnboarding={false}
                  //   afterConnect={() => {
                  //     this.setState({ openCheckout: false });
                  //     this.setState({ isReadyToPay: true });
                  //   }}
                  //   subscriptionStyle="position:relative; bottom:10px;"
                  // />
                )}
                {spinnerShown && <Spinner />}
              </div>
            </div>
          )
        }
      </InfoContainer >
    );
  }
}

CourseOffer.propTypes = {
  settingsStore: PropTypes.object,
};

export default CourseOffer;
